// @ts-check
import classNames from 'classnames';
import { graphql } from 'gatsby';
import React from 'react';
import GatsbyImage from '../components/images/GatsbyImage';

import './CollageBlock.scss';

export const query = graphql`
	fragment CollageFragment on Ozk_content_blockModular_blocksCopyContent {
		collage {
			alignment
			images {
				...BynderImageFragment
			}
		}
	}
`;
/**
 * @typedef CollageBlockOptions
 * @property {'left' | 'center' | 'right'} alignment
 * @property {import('../CSTypes').BynderImageOptions[]} images
 *
 * @typedef CollageBlockProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<CollageBlockOptions>} [options]
 */
/** @type {import('~/types/React').ReactFC<CollageBlockProps>} */
const CollageBlock = ({ options, ...rest }) => (
	<div {...rest} className={classNames(rest.className, 'collage-block')} style={{ alignItems: options.alignment }} {...options.$?.alignment}>
		{options.images.map((img, i) => (
			<GatsbyImage key={i} className="swatch" option={img} />
		))}
	</div>
);

export default CollageBlock;
